import * as React from "react";
import { Card } from "../../card/card/card.mjs";
import { CardContent } from "../../card/card-content/card-content.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
import { List } from "../../list/list/list.mjs";
const ArrowListContext = React.createContext({});
const ArrowList = (props) => {
  const {
    outerBordered = false,
    type = "unstyled",
    className,
    iconClassName,
    purpose,
    itemsMargin = "tiny",
    itemsPadding,
    heading,
    theme,
    backgroundColor,
    backgroundHover,
    large,
    ...rest
  } = props;
  const arrowListContextValue = {
    purpose,
    iconClassName,
    theme,
    backgroundHover,
    backgroundColor,
    large
  };
  const BEM = () => {
    const classArray = ["arrow-list"];
    if (className) {
      classArray.push(className);
    }
    if (large) {
      classArray.push("arrow-list--large");
      if (type === "icon") {
        classArray.push("arrow-list--with-icon");
      }
      if (itemsMargin) {
        classArray.push("arrow-list--margin-".concat(itemsMargin));
      }
      if (itemsPadding) {
        classArray.push("arrow-list--padding-".concat(itemsPadding));
      }
      if (heading) {
        classArray.push("arrow-list--with-heading");
      }
    }
    if (purpose) {
      classArray.push("arrow-list--purpose-".concat(purpose));
    }
    return classArray.join(" ");
  };
  const getHeaderBackgroundColor = () => {
    switch (backgroundColor) {
      case "beige":
        return "brand-secondary-bg-subtlest";
      case "white":
        return "neutral-bg-level-1";
      default:
        return "neutral-bg-level-2";
    }
  };
  return /* @__PURE__ */ React.createElement(ArrowListContext.Provider, { value: arrowListContextValue }, /* @__PURE__ */ React.createElement("div", { className: BEM() }, heading && large && /* @__PURE__ */ React.createElement(Card, { background: "transparent" }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement(
    CardContent,
    {
      background: getHeaderBackgroundColor(),
      borderRadius: {
        top: "medium",
        bottom: "none"
      }
    },
    /* @__PURE__ */ React.createElement(Heading, { ...heading }, heading.children)
  )))), /* @__PURE__ */ React.createElement(List, { ...rest, outerBordered, type, bordered: true, fullWidth: true, theme })));
};
export {
  ArrowList,
  ArrowListContext
};
